import React from 'react'
import { connect } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { v4 } from 'uuid';
import { routers } from '../../../Constants/routers';
import { updateChatHistory } from '../../../Redux/Chats/actions';

const DesktopChatList = (props) => {
	let { currentUser } = useParams();

    return (
        <ul 
            id="conversations-list" 
            // className="animated preFadeInUp fadeInUp"
            key={v4()}
    >
        {props?.chatlist?.length > 0 &&
            props?.chatlist.map((e) => {
                return (
                    <li
                        id={e.username}
                        className={
                            currentUser === e?.username
                                ? "is-active"
                                : ""
                        }
                        data-conversation-menu={e.username}
                        data-position="Business Analyst"
                        // onClick={() => props?.loadChat(e?.username)}
                        key={v4()}
                    >
                        <Link className="recent-user"
                            to={routers.dashboard.messanger(e.username)}
                        >
                            <div className="user-container">
                                <img
                                    className="is-user"
                                    src={
                                        e?.image ||
                                        require("../../../assets/images/placeholder.png")
                                            .default
                                    }
                                    alt=""
                                />
                                <div
                                    className={`badge ${
                                        e.is_active ? "bg-success" : "bg-danger"
                                    } status-badge`}
                                />
                            </div>
                            <div className="recipient-meta">
                                <span>{e.name}</span>
                                <span>3 minutes ago</span>
                                {e.unread > 0 && <div className="unread-counter" style={{ right: 20, top: "calc(50% - 7.5px)" }}>{e.unread}</div>}
                            </div>
                        </Link>
                    </li>
                );
            })}
    </ul>
    )
}



const mapStateToProps = ({ chats }) => {
	return { chatlist: chats?.chatlist || [] };
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateChatHistory: (e, u) => dispatch(updateChatHistory(e, u)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(DesktopChatList);
